<template>
  <header>
  <div class="headerLeft">
  <img src="@/assets/images/Rlogo2.svg"/>
  </div>
  <div class="headerRight">
  <div class="headerRightContent">
  <el-select class="language" v-model="lang" placeholder="简体中文" @change='changlan()'>
    <el-option value="CHS" label="简体中文">
    </el-option>
    <el-option value="ENG" label="English">
    </el-option>
    <el-option value="JP" label="日本語">
    </el-option>
  </el-select>
  <div class="userInfo">
  <img v-if="showPortrait" :src="portrait"/>
  <img v-if="!showPortrait" src="@/assets/images/portrait.svg"/>
  <div class="name">
  <span :title="userName" v-if="userName.slice(0, 3) !== 'wx|' || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{userName}}</span>
  <span v-if="userName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" style="height: 18px;width: 100%;font-size: 14px;line-height: 18px;">
    <ww-open-data v-if="userName.slice(0, 3) === 'wx|'" type="userName" :openid="userName.slice(3)"></ww-open-data>
  </span>
  <span :title="ownerName" class="ownerName">{{ownerName}}</span>
  </div>
  </div>
  <div class="assistant" @click="addTab($t('LanguageLib.IMPORT_ASSISTANT'),'/importassistant/importlist','importlist')">
  <i class="iconfont">&#xe60f;</i>
  <span>{{$t('LanguageLib.IMPORT_ASSISTANT')}}</span>
  </div>
  <div class="logout" @click="logout()">
  <i class="iconfont">&#xe611;</i>
  <span>{{$t('LanguageLib.InfoLogOut')}}</span>
  </div>
  </div>
  </div>
    <!--{{$t('LanguageLib.header')}}-->
    <!--<el-button @click="changlan">默认按钮</el-button>-->
  </header>
</template>

<script>
export default {
  data () {
    return {
      Tabs: [
        {
          title: this.$t('LanguageLib.HOME_PAGE'),
          topath: '/home',
          keys: 'home'
        }
      ],
      lang: window.localStorage.getItem('lang'), // 语言类型
      userName: window.localStorage.getItem('userName'), // 用户名
      ownerName: window.localStorage.getItem('ownerName'), // 公司名
      portrait: window.localStorage.getItem('portrait'), // 用户头像
      showPortrait: window.localStorage.getItem('portrait') !== ''// 是否显示占位图
    }
  },
  created () {
    this.lang = this.$commonfun.localStorage.getitem('lang') ? this.$commonfun.localStorage.getitem('lang') : 'CHS'
    if (this.lang === 'CHS') {
      this.$i18n.locale = 'zh'//  切换语言
    }
    if (this.lang === 'ENG') {
      this.$i18n.locale = 'en'//  切换语言
    }
    if (this.lang === 'JP') {
      this.$i18n.locale = 'jp'//  切换语言
    }
  },
  methods: {
    changlan () {
      this.$commonfun.localStorage.setitem('lang', this.lang)
      //    if (this.lang === 'CHS') {
      //      this.$i18n.locale = 'zh'//  切换语言
      //    }
      //    if (this.lang === 'ENG') {
      //      this.$i18n.locale = 'en'//  切换语言
      //    }
      //    if (this.lang === 'JP') {
      //      this.$i18n.locale = 'jp'//  切换语言
      //    }
      this.$router.go(0)
    },
    // 点击导航菜单
    addTab (title, topath, keys) {
      this.$commonfun.localStorage.setitem('title', title)
      this.$commonfun.localStorage.setitem('topath', topath)
      this.$commonfun.localStorage.setitem('keys', keys)
      var exist = false
      for (var i = 0; i < this.Tabs.length; i++) {
        if (title === this.Tabs[i].title) {
          exist = true
          break
        }
      }
      if (exist === true) {
        this.TabsValue = title
        // 路由跳转
        if (this.$route.path === topath) {
        } else {
          this.$router.push({ path: topath, query: { navisshow: this.isCollapse } })
        }
        return
      }
      this.Tabs.push({
        title: title,
        topath: topath,
        keys: keys
      })
      this.TabsValue = title
      // 路由跳转
      if (this.$route.path === topath) {
      } else {
        this.$router.push({ path: topath, query: { navisshow: this.isCollapse } })
      }
    },
    // 退出登录
    logout () {
      // this.$commonfun.localStorage.clearall()
      this.$commonfun.localStorage.setitem('loginstatus', false)
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss">
header{
  height: 60px;
  width: 100%;
  min-width: 1280px;
  position: fixed;
  top: 0;
  .headerLeft{
    height: 100%;
    width: 160px;
    float: left;
    img{
      height: 100%;
    }
  }
  .headerRight{
    height: 100%;
    width: calc( 100% - 160px );
    float:left;
    .headerRightContent{
      height: 100%;
      overflow:hidden;
      /*width: 500px;*/
      padding-right: 50px;
      float:right;
      .language{
        height: 40px;
        border:none;
        border-radius: 0;
        width: 100px;
        font-size: 12px;
        margin-top: 10px;
        /*border-left: 1px solid #C9C9C9;*/
        float:left;
        position: relative;
        padding-left: 20px;
        .iconfont{
          position: absolute;
          top: 10px;
          left: 10px;
          font-size: 19px;
          color: #666;
        }
        input{
          background: none;
          border: 0;
        }
      }
      .userInfo{
        float: left;
        /*width: 240px;*/
        padding-right: 10px;
        height: 40px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        border-right: 1px solid #C9C9C9;
        img{
          width:30px;
          height:30px;
          border-radius: 50%;
          float:left;
        }
        .name{
          float:left;
          padding-left: 5px;
          position: relative;
          span{
            display: block;
            text-align:left;
            white-space: nowrap;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span:nth-of-type(1){
            font-size: 14px;
          }
          .ownerName{
            font-size: 12px;
          }
        }
      }
        .assistant{
          float: left;
          height: 40px;
          margin-top: 10px;
          padding: 0 10px;
          display: flex;
          align-items: center;
          border-right: 1px solid #C9C9C9;
          i{
            font-size: 19px;
            color: #666;
          }
          span{
            font-size: 12px;
            margin-left: 3px;
          }
        }
        .logout{
          float: left;
          height: 100%;
          padding-left: 5px;
          display: flex;
          align-items: center;
          i{
            font-size: 19px;
            font-weight: 600;
            color: #666;
          }
          span{
            font-size: 12px;
            margin-left: 3px;
          }
      }
    }
  }
}
</style>
